import React from 'react';
import { useAuth } from '../context/AuthContext';
import AvailabilityNotification from './AvailabilityNotification';
import FriendsNotification from './FriendsNotification';
import PreferencesNotification from './PreferencesNotification';
import TermsNoticeBanner from './TermsNoticeBanner';

const GlobalNotifications = () => {
  const { 
    availabilityNotification, 
    dismissAvailabilityNotification,
    friendsNotification,
    dismissFriendsNotification,
    preferencesNotification,
    dismissPreferencesNotification
  } = useAuth();

  return (
    <>
      <TermsNoticeBanner />
      <AvailabilityNotification
        show={availabilityNotification.show}
        message={availabilityNotification.message}
        onDismiss={dismissAvailabilityNotification}
      />
      <FriendsNotification
        show={friendsNotification.show}
        message={friendsNotification.message}
        onDismiss={dismissFriendsNotification}
      />
      <PreferencesNotification
        show={preferencesNotification.show}
        message={preferencesNotification.message}
        onDismiss={dismissPreferencesNotification}
      />
    </>
  );
};

export default GlobalNotifications;
